import {roomsToConfigurationObject} from '@vio/core/src/room/business/roomConfiguration'

const getRoomConfig = (params: {rooms: string}) => {
  return roomsToConfigurationObject(params?.rooms)
}

export default getRoomConfig
